angular.module( 'acme.view.application.layouts.tickets.create.definition', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.layouts.tickets.create.definition.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var layoutsTicketsCreateDefinition = {
        name: 'application.layouts.tickets.create.definition',
        url: '/definition',
        views: {
          "subview-main": {
            controller: 'LayoutsTicketsCreateDefinitionController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/layouts/tickets/create/definition/definition.tpl.html'
          }
        },
        data: {
          pageTitle: 'Create Ticket Layout'
        }
    },
    layoutsTicketsEditDefinition = {
      name: 'application.layouts.tickets.edit.definition',
      url: '/definition',
      views: {
        "subview-main": {
          controller: 'LayoutsTicketsCreateDefinitionController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/layouts/tickets/create/definition/definition.tpl.html'
        }
      },
      data: {
        pageTitle: 'Edit Ticket Layout'
      }
    };

    $stateProvider
      .state(layoutsTicketsCreateDefinition)
      .state(layoutsTicketsEditDefinition);
});
